/* jshint esversion: 6 */

import {LoggingService} from "logging/LoggingService";

const DEFAULT_HEX_MAP = [
          ["A3", "{"],
          ["A5", "}"],
          ["A9", "a"],
          ["AB", "H"],
          ["AC", "b"],
          ["AD", "."],
          ["AE", "I"],
          ["AF", "c"],
          ["B0", "J"],
          ["B1", "-"],
          ["B2", "d"],
          ["B3", "]"],
          ["B5", "e"],
          ["B6", "+"],
          ["B7", "K"],
          ["B8", "f"],
          ["B9", "@"],
          ["BA", "*"],
          ["BB", "g"],
          ["BC", "L"],
          ["BD", "M"],
          ["BE", "h"],
          ["BF", "/"],
          ["C1", "i"],
          ["C2", "N"],
          ["C3", "="],
          ["C4", "j"],
          ["C5", "O"],
          ["C6", "P"],
          ["C7", "k"],
          ["C8", "_"],
          ["CA", "l"],
          ["CC", ","],
          ["CD", "m"],
          ["CE", "R"],
          ["CF", "S"],
          ["D0", "n"],
          ["D1", "!"],
          ["D2", "T"],
          ["D3", "o"],
          ["D4", "U"],
          ["D5", "#"],
          ["D6", "p"],
          ["D7", "V"],
          ["D8", "W"],
          ["D9", "q"],
          ["DA", "$"],
          ["DC", "r"],
          ["DE", "%"],
          ["DF", "s"],
          ["E0", "X"],
          ["E2", "t"],
          ["E3", "&"],
          ["E5", "u"],
          ["E7", "("],
          ["E8", "v"],
          ["EA", "["],
          ["EB", "w"],
          ["EC", ")"],
          ["ED", "|"],
          ["EE", "x"],
          ["EF", ">"],
          ["F0", ":"],
          ["F1", "y"],
          ["F2", "Y"],
          ["F4", "z"],
          ["F5", ";"],
          ["F6", "<"],
          ["FA", "G"],
          ["FB", "Q"],
          ["FD", "Z"],
          ["FE", "^"]
        ];

/**
 * A given _hexMap must not contain the values A,B,C,D,E,F!!!!
 * They will collide with the given keys!!!
 */
function getCustomHexMap(){

    if( !window.CEncryptionService || !window.CEncryptionService._hexMap ) {
        return null;
    }

    const hexMap = new Map();
    Object.keys(window.CEncryptionService._hexMap).forEach(key => {
        hexMap.set(key, window.CEncryptionService._hexMap[key]);
    });

    return hexMap;
}

function validateHexMap( hexMap ){

    if( !hexMap || hexMap.size !== 72){
        return false;
    }

    return !hasDuplicateEntries( hexMap );
}

function hasDuplicateEntries( mapToCheck ){

    const valueSet = new Set( mapToCheck.values() );

    return valueSet.size !== mapToCheck.size;
}

export const EncryptionModifier = {
    getCodeOrVal: () => 0x89,
    getDefaultCryptToken: () => 0x2A,
    getHexMap: () => {

        const customHexMap = getCustomHexMap();
        if( customHexMap ){

            if( validateHexMap( customHexMap ) ){
                return customHexMap;
            }

            LoggingService.error( "custom hexmap is defined, but invalid!")
        }

        return new Map(DEFAULT_HEX_MAP);
    },
    validateHexMap: validateHexMap
};
